export type Role = 'admin' | 'reception' | 'atelier' | 'mecanicien';
export type Specialite = 'rapide' | 'mecanique' | 'lavage';
export type TypeAgenda = 'rapide' | 'mecanique' | 'lavage';
export type Statut =
  | 'CONFIRME'
  | 'EN_ATTENTE'
  | 'EN_COURS'
  | 'ATTENTE_PIECES'
  | 'TERMINE'
  | 'LIVRE'
  | 'ANNULE';

export type Mechanic = {
  id: string;
  prenom: string;
  nom: string;
  specialite: Specialite;
  couleur: string;
  actif: boolean;
  ordreAffichage: number;
};

export type Client = {
  id: string;
  nom: string;
  prenom: string;
  telephone: string;
  email: string | null;
};

export type Motorcycle = {
  id: string;
  modele: string;
  vin: string;
  kilometrage: number | null;
  annee?: number | null;
};

export type Intervention = {
  id: string;
  clientId: string;
  motoId: string;
  mecanicienId: string;
  typeAgenda: TypeAgenda;
  nature: string;
  description: string | null;
  dureeEstimeeMinutes: number;
  dateRdv: string;
  creneauDebut: string;
  creneauFin: string;
  statut: Statut;
  urgent: boolean;
  kilometrageEntree: number | null;
  livraisonEstimee: string;
  livraisonConfirmee: string | null;
  flagDecale: boolean;
  numeroServiceKtm: string | null;
  client: Pick<Client, 'id' | 'nom' | 'prenom' | 'telephone'>;
  moto: Pick<Motorcycle, 'id' | 'modele' | 'vin' | 'kilometrage'> & {
    annee?: number | null;
  };
  mecanicien: Pick<Mechanic, 'id' | 'prenom' | 'nom' | 'couleur' | 'specialite'>;
};

export type AttentePiecesItem = Intervention & {
  attentePiecesDepuis: string | null;
};

export const STATUT_LABELS: Record<Statut, string> = {
  CONFIRME: 'Confirmé',
  EN_ATTENTE: 'En attente',
  EN_COURS: 'En cours',
  ATTENTE_PIECES: 'Attente pièces',
  TERMINE: 'Terminé',
  LIVRE: 'Livré',
  ANNULE: 'Annulé',
};

export const TYPE_AGENDA_LABELS: Record<TypeAgenda, string> = {
  rapide: 'Service Rapide',
  mecanique: 'Mécanique',
  lavage: 'Lavage',
};
